export function scrollToHash(hash) {
  const el = hash && document.querySelector(hash);
  if (!el) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (window.__lenis && !reduce) {
    window.__lenis.scrollTo(el, { offset: -88, duration: 1.1 });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY - 88;
    window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
  }
}
